/**
 * A global namespace for `keyup` event.
 * @type {string}
 */
const keyupEvent = 'keyup';
export default keyupEvent;
